// Utils
import handleConvertToTask from './handleConvertToTask';

export default (event, editorState, draftProps) => handleConvertToTask(editorState, draftProps);
